<script setup lang="ts">
type Props = { currentCity: string; cityVisibleName: string }

const props = defineProps<Props>()

const city = ref(props.cityVisibleName)

watch(
  () => props.currentCity,
  (nextValue) => {
    city.value = nextValue
  },
)
</script>

<template>
  <the-button
    icon="fill-location"
    radius="lg"
    size="sm"
    font="sm"
    variant="tertiary"
  >
    {{ city }}
  </the-button>
</template>
